export default __webpack_public_path__ + "static/media/x.6ca858f6.svg";